import React from 'react';
import '../../styles/layout/footer.css';

const Footer = () => {
  return (
    <footer className="mn_ft">
      Copyright © GCCEI. All rights reserved.
    </footer>
  );
};

export default Footer; 